module.exports = __webpack_public_path__ + "static/media/rightGray.c05cbff4.svg";